<template>
  <div class="faq-block">
    <div class="row">
      <div class="col-lg-12">
        <div
          class="faq-block__question-answer"
          v-for="faq in faqs"
          :key="faq.question"
        >
          <div class="faq-block__question">
            <p>
              <span class="sk-fqa-q">Q: </span> {{ faq.question
              }}<span class="sk-fqa-arrow"></span>
            </p>
          </div>
          <div class="faq-block__answer">
            <p v-html="faq.answer"></p>
            <p class="faq-block__link" v-html="faq.link"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import questions from '../data/support-faqs.json';

export default {
  data() {
    return {
      faqs: questions
    };
  },
  mounted() {
    this.questions = this.$el.querySelectorAll('.faq-block__question');

    $(this.questions).click(function() {
      $(this).toggleClass('active');
      $(this)
        .next('.faq-block__answer')
        .slideToggle();
    });
  }
};
</script>
